module.exports = __webpack_public_path__ + "img/zs43.c8bb35a7.jpg";